export default __webpack_public_path__ + "static/media/FAKEAPP_Dashboard.bf16f464.svg";